<template>
  <div id="Tools">
    <sidebar-menu :menu="menu" @item-click="onItemClick" />
    <component v-bind:is="selectedMenu"></component>
  </div>
</template>

<script>
import repricing from "./repricing.vue";
import investor from "./investor.vue";
import cmsdatapull from "./cmsdatapull.vue";
import titlesearch from "./titlesearch.vue";
import generatebio from "./generate_bio.vue";
import askde from "./askde.vue";
import trending from "./trending.vue";

export default {
  name: "Tools",

  components: {
    repricing,
    investor,
    cmsdatapull,
    titlesearch,
    generatebio,
    askde,
    trending
  },

  data() {
    return {
      selectedMenu: "repricing",

      menu: [
        {
          href: "#repricing",
          title: "Repricing",
          icon: "fa fa-user",
          componentName: "repricing",
        },
        {
          href: "#investor",
          title: "Investor Report",
          icon: "fa fa-user",
          componentName: "investor",
        },
        {
          href: "#cmsdatapull",
          title: "CMS Data Pull",
          icon: "fa fa-user",
          componentName: "cmsdatapull",
        },
        {
          href: "#titlesearch",
          title: "Title Search",
          icon: "fa fa-user",
          componentName: "titlesearch",
        },
        {
          href: "#trending",
          title: "Trending",
          icon: "fa fa-user",
          componentName: "trending",
        },
        {
          href: "#generatebio",
          title: "Generate Bio",
          icon: "fa fa-user",
          componentName: "generatebio",
        },
        {
          href: "#askde",
          title: "Ask DE",
          icon: "fa fa-user",
          componentName: "askde",
        },
      ],
    };
  },

  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },

    onItemClick(event, item) {
      this.selectedMenu = item.componentName;
    },
  },
};
</script>
